/* eslint-disable import/no-cycle */
import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Space} from 'antd';
import {faListAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from '../shared/buttons/Button';
import {smallPaginationPreset} from '../shared/tables/paginationPresets';
import {TableColumns} from '../shared/tables/columns';
import BatchLogTableAction from './BatchLogTableAction';
import WidgetTable from '../shared/widgets/WidgetTable';
import {useMount} from '../../hooks/useMount';
import {useStore} from '../../hooks/useStore';

const BatchLogTable = ({yieldLogs = [], columns, loading, onView, sortOrder, onExport}) => {
  const store = useStore();
  const [update, setUpdate] = useState(false);

  useMount(() => {
    setUpdate(!update);
  }, [
    store.materialStore.materials.length,
    store.operationStore.operations.length,
    store.orderStore.orders.length,
    store.batchStore.batches.length,
    store.yieldTypeStore.yieldTypes.length,
  ]);

  return (
    <Space size={'middle'} direction={'vertical'} style={{display: 'flex'}}>
      {onExport && (
        <BatchLogTableAction
          onExport={onExport}
        />
      )}
      <WidgetTable
        loading={loading}
        size={'middle'}
        columns={[
          TableColumns.id({defaultSortOrder: sortOrder}),
          ...columns,
          {
            dataIndex: '',
            key: 'actions',
            align: 'right',
            width: 50,
            render: (_, record) => (
              <Button type="default" icon={<FontAwesomeIcon icon={faListAlt}/>} onClick={() => onView(record)}/>
            ),
          },
        ]}
        dataSource={yieldLogs}
        rowKey={'id'}
        pagination={smallPaginationPreset}
      />
    </Space>
  );
};

export default observer(BatchLogTable);
